import React from 'react';
import { Redirect } from 'react-router-dom';

const Tools = () => {
  return (
    <Redirect
      to={{
        pathname: '/live',
      }}
    />
  );
};

export default Tools;



// WEBPACK FOOTER //
// ./src/container/tools.js